import { render, staticRenderFns } from "./NetlinkThema.vue?vue&type=template&id=8bb20c00&scoped=true"
import script from "./NetlinkThema.vue?vue&type=script&lang=js"
export * from "./NetlinkThema.vue?vue&type=script&lang=js"
import style0 from "./NetlinkThema.vue?vue&type=style&index=0&id=8bb20c00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bb20c00",
  null
  
)

export default component.exports